import * as types from "./ActionTypes";

const ApiCalls = Object.freeze({
  [types.LOAD_UTILIZATION_SUCCESS]: 0,
  [types.LOAD_AVAILABLE_HOURS_SUCCESS]: 1,
  [types.LOAD_AVAILABLE_HOURS_HISTORY_SUCCESS]: 2,
  [types.LOAD_ELIGABLE_HOURS_SUCCESS]: 3,
  [types.CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS]: 4,
  [types.LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS]: 5,
  [types.SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS]: 6,
  [types.UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS]: 7,
  GET_REV_SHARE_USAGE_TYPES: 8,
  [types.LOAD_TODAY_INFORMATION_SUCCESS]: 9,
  [types.LOAD_USER_PROFILE_SUCCESS]: 10,
  [types.LOAD_ACTIVE_CONSULTANT_LIST_SUCCESS]: 11,
  [types.LOAD_UTILIZATIO_REQUEST_STATUSES_SUCCESS]: 12,
  [types.LOAD_HOURS_TRANSACTION_TYPES_SUCCESS]: 13,
  [types.UPDATE_USEFULNESS_SCORE_SUCCESS]: 14,
  [types.REMOVE_FAQ_SUCCESS]: 15
});

export function numberOfCalls() {
  return Object.keys(ApiCalls).length;
}

export default ApiCalls;
